var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightSwitchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 61,
    viewBox: "0 0 42 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 61,
    rx: 2,
    fill: "#668BA6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 22,
    height: 41,
    fill: "#E5ECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L13 9V29L22 47L10 51V10Z",
    fill: "#CCD8E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 47H42L32 51H10L20 47Z",
    fill: "#BACAD6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 22,
    height: 20,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29H35L42 47H20L13 29Z",
    fill: "#F5F7F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5516 22.12C21.3816 22.12 22.2516 21.23 22.2516 19.38V17.82C22.2516 15.97 21.3816 15.08 19.5516 15.08C17.7216 15.08 16.8516 15.97 16.8516 17.82V19.38C16.8516 21.23 17.7216 22.12 19.5516 22.12ZM19.5516 21.05C18.5116 21.05 18.0716 20.54 18.0716 19.37V17.83C18.0716 16.66 18.5116 16.15 19.5516 16.15C20.5916 16.15 21.0316 16.66 21.0316 17.83V19.37C21.0316 20.54 20.5916 21.05 19.5516 21.05Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8141 22H25.0141V17.74H26.2341V16.81H25.0141V16.38C25.0141 15.85 25.1841 15.65 25.6541 15.65H26.2841V14.7H25.2941C24.3041 14.7 23.8141 15.24 23.8141 16.36V16.81H22.9441V17.74H23.8141V22Z",
    fill: "#3A3A3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2027 22H28.4027V17.74H29.6227V16.81H28.4027V16.38C28.4027 15.85 28.5727 15.65 29.0427 15.65H29.6727V14.7H28.6827C27.6927 14.7 27.2027 15.24 27.2027 16.36V16.81H26.3327V17.74H27.2027V22Z",
    fill: "#3A3A3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9606 40.3658C27.7906 40.3658 28.3234 39.5421 27.6226 37.83L27.0317 36.3863C26.3309 34.6741 25.1238 33.8505 23.2938 33.8505C21.4638 33.8505 20.9309 34.6741 21.6317 36.3863L22.2226 37.83C22.9234 39.5421 24.1306 40.3658 25.9606 40.3658ZM25.5552 39.3755C24.5152 39.3755 23.8821 38.9036 23.4388 37.8207L22.8555 36.3955C22.4123 35.3127 22.6591 34.8407 23.6991 34.8407C24.7391 34.8407 25.3723 35.3127 25.8155 36.3955L26.3988 37.8207C26.8421 38.9036 26.5952 39.3755 25.5552 39.3755Z",
    fill: "#3A3A3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9571 40.2547H31.1571L29.8806 37.1359C29.9471 36.5899 30.2172 36.3215 30.7072 36.3215C31.2072 36.3215 31.5571 36.5899 31.7995 37.1822L33.0571 40.2547H34.2571L32.9578 37.0804C32.4881 35.9328 31.6957 35.3405 30.6157 35.3405C29.9357 35.3405 29.5204 35.5718 29.3201 36.1086L29.0111 35.4515H27.9911L29.9571 40.2547Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSwitchOff);
export default __webpack_public_path__ + "static/media/light-switch-off.4fd09d53f8122cfbbb4d20e8a4b086ce.svg";
export { ForwardRef as ReactComponent };